import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsAnalyticsDataViewListRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-assets-analytics-data-view-list',
	path: '/jira/servicedesk/assets/analytics/data-view',
	exact: true,
};
